export var IntelligentPhotoCaptureApplicationType;
(function (IntelligentPhotoCaptureApplicationType) {
    IntelligentPhotoCaptureApplicationType["MIPC_ESTIMATOR"] = "MIPC-Estimator";
    IntelligentPhotoCaptureApplicationType["PBE"] = "PBE";
})(IntelligentPhotoCaptureApplicationType || (IntelligentPhotoCaptureApplicationType = {}));
//# sourceMappingURL=IntelligentPhotoCaptureApplicationType.js.map